import React, { Component } from 'react'
import Card from './card'
import CardContainer from './card-container'
import CardHolder from '../card-holder/cardHolder'
import CardTitle from '../card-title/card-title'
import { getCall } from '../../../../helpers/api'

class ColorCardsExample extends Component {

    constructor(props) {
        super(props)
        this.state = {
            colors: []
        }
        this.calculateColor = this.calculateColor.bind(this)
    }

    async componentDidMount() {
        const colors = await getCall("/color/getall")
        await this.setState({ colors: colors.data })
    }

    calculateColor(colorc, index) {
        let color = null
        if (color === "mix")
            color = "conic-gradient( #ffa600,#ffa600,#e90123,#f7f700,#660099,#008000,#002fa7,#ffa600,#e90123,#f7f700,#660099,#008000,#002fa7,#ffa600)"
        else
            color = colorc

        return <Card key={index} history={this.props.history} color={color} />
    }

    render() {
        return (
            <CardContainer>
                <CardTitle title="Çiçeğinizin Rengini Seçin" />
                <CardHolder>
                    {this.state.colors.map((c, index) => (
                        this.calculateColor(c.color, index)
                    ))}

                </CardHolder>
            </CardContainer>
        )
    }
}

export default ColorCardsExample
